import { GET_OPERADORES_MONGO } from './mutation-types'
import operadoresHttpService from '../_services/operadoresHttpService'

export default {
  listarOperadoresLogadosNoBanco: async ({ commit }) => {
    try {
      const response = await operadoresHttpService.getOperadores()
      commit(GET_OPERADORES_MONGO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
